import { render, staticRenderFns } from "./DIASBuyersPreview.vue?vue&type=template&id=52de01fc&"
import script from "./DIASBuyersPreview.vue?vue&type=script&lang=js&"
export * from "./DIASBuyersPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports